// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalsController from "./modals_controller"
application.register("modals", ModalsController)

import NotesNewController from "./notes_new_controller"
application.register("notes-new", NotesNewController)

import NotesVideoController from "./notes_video_controller"
application.register("notes-video", NotesVideoController)

import PublicVideoController from "./public_video_controller"
application.register("public-video", PublicVideoController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import UserVideoEventController from "./user_video_event_controller"
application.register("user-video-event", UserVideoEventController)

import VideoPickerController from "./video_picker_controller"
application.register("video-picker", VideoPickerController)

import WelcomeLightboxController from "./welcome_lightbox_controller"
application.register("welcome-lightbox", WelcomeLightboxController)
